/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id              = 'pageAdd',
    app             = require('mag-app'),
    appConf         = require('../config'),
    Page            = require('stb-component-page'),
    page            = new Page({$node: document.getElementById(id)}),
    dom             = require('spa-dom'),
    PanelSet        = require('mag-component-panel-set'),
    PanelExtended   = require('mag-component-panel'),
    LayoutList      = require('mag-component-layout-list'),
    ModalMessage    = require('mag-component-modal'),
    RadioList       = require('mag-component-radio-list'),
    Button          = require('stb-component-button'),
    Flicker         = require('spa-component-flicker'),
    keys            = require('stb-keys'),
    tools           = require('../modules/tools'),
    downloadManager = window.core.plugins.downloadManager;


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

// modal message: select device
page.modalSelectDevice = new ModalMessage({
    title: gettext('devices'),
    className: 'modalSelectDevice',
    visible: false,
    events: {
        show: function () {
            var body = [],
                index;

            for ( index = 0; index < appConf.storages.length; index++ ) {
                body.push({state: !index, title: appConf.storages[index].label, value: appConf.storages[index]});
            }
            this.children[0].init({data: body, size: body.length, focusIndex: 0});
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    page.modalSelectDevice.hide();
                    page.reset({storage: event.$item.data.value});
                }
            }
        })
    ]
});
page.add(page.modalSelectDevice);


// panel: add new download
page.panelAdd = new PanelExtended({
    title: gettext('new download'),
    main: true,
    visible: true,
    className: 'panelAdd'
});

page.panelAdd.add(page.panelAdd.list = new LayoutList({
    focusIndex: 0,
    size: 2,
    events: {
        overflow: function () {
            page.panelAdd.list.$focusItem.classList.remove('focus');
            page.panelAdd.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: [
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('URL:')},
                page.panelAdd.input = dom.tag('div', {className: 'item text'}),
                {className: 'item placeholder theme-item-editable', value: ''}
            ],
            click: function () {
                window.core.intent({
                    action: 'keyboard',
                    data: {
                        type: 'text',
                        mode: 'qwerty',
                        title: gettext('ENTER URL'),
                        description: gettext('DOWNLOADS'),
                        value: page.panelAdd.input.innerText
                    },
                    events: {
                        done: function ( event ) {
                            page.panelAdd.input.innerText = event.value;
                        }
                    }
                }, function ( error ) {
                    console.log(error);
                });
            }
        }, {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('Device:')},
                {className: 'item text', value: gettext('Connect device')},
                {className: 'item placeholder theme-item-more', value: ''}
            ],
            click: function () {
                if ( appConf.storages.length ) {
                    page.panelSet.blur();
                    page.modalSelectDevice.show();
                    page.panelSet.visible = false;
                }
            }
        }
    ]
}));

page.panelAdd.add(page.panelAdd.button = new Button({
    value: gettext('Create'),
    className: 'bottom theme-footer',
    $node: page.panelAdd.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            if ( page.panelAdd.currStorage ) {
                tools.checkSize(page.panelAdd.input.innerText, function ( length ) {
                    var fileName;

                    if ( length > page.panelAdd.currStorage.freeSize ) {
                        window.core.notify({
                            title: gettext('Not enough free space in storage') + ' ' + gettext('File size:') +
                            ' ' + tools.convert(length || 0) + gettext('Free space:') + ' ' +
                            tools.convert(page.panelAdd.currStorage ? page.panelAdd.currStorage.freeSize : 0),
                            icon: 'alert',
                            type: 'warning'
                        });
                    } else if ( page.panelAdd.currStorage ) {
                        //console.log('url:' + page.panelAdd.input.innerText);
                        //console.log('click->start ' + (page.panelAdd.currStorage ? (page.panelAdd.currStorage.mountPath
                        //   + '/' + page.panelAdd.input.innerText.split('/').pop()) : ''));
                        if ( app.intent && app.intent.data && app.intent.data.title ) {
                            fileName = page.panelAdd.currStorage.mountPath + '/' + app.intent.data.title;
                        } else {
                            fileName = page.panelAdd.currStorage.mountPath + '/' + page.panelAdd.input.innerText.split('/').pop();
                        }
                        downloadManager.add({
                            url: page.panelAdd.input.innerText,
                            name: fileName
                        }, function ( error ) {
                            if ( error ) {
                                window.core.notify({title: error.message, icon: 'alert', type: 'warning'});
                            } else {
                                if ( app.intent && app.intent.close ) {
                                    app.intent.close();
                                    app.intent = null;
                                }
                                app.route(app.pages.main);
                            }
                        });
                    }
                });
            }
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.panelAdd.list.$focusItem.classList.add('focus');
                page.panelAdd.list.focus();
                page.panelAdd.list.focusIndex(page.panelAdd.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.panelAdd.list.$focusItem.classList.add('focus');
                page.panelAdd.list.focus();
                page.panelAdd.list.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.panelAdd.button.events['click'] ) {
                    page.panelAdd.button.emit('click', {event: event});
                }
            }
        }
    }
}));

// panel set: add download
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetAdd'),
    focusIndex: 0,
    panels: [page.panelAdd]
});
page.add(page.panelSet);

page.reset = function ( config ) {
    var text, free, all;

    if ( config && config.storage ) {
        free = gettext('Free space:') + ' ' + tools.convert(config.storage.freeSize);
        all = tools.convert(config.storage.size);
        text = '<div class="itemHalf">' + config.storage.label + '</div><div class="itemHalf">' + free + gettext(' of ') + all + '</div>';
        page.panelAdd.currStorage = config.storage;
    } else if ( appConf.storages.length ) {
        free = gettext('Free space:') + ' ' + tools.convert(appConf.storages[0].freeSize);
        all = tools.convert(appConf.storages[0].size);
        text = '<div class="itemHalf">' + appConf.storages[0].label + '</div><div class="itemHalf">' + free + gettext(' of ') + all + '</div>';
        page.panelAdd.currStorage = appConf.storages[0];
    } else {
        text = gettext('Connect device');
        page.panelAdd.currStorage = null;
    }

    if ( app.intent ) {
        page.panelAdd.input.innerText = app.intent.data.uri;
    }

    page.panelAdd.list.$body.children[1].children[0].children[1].innerHTML = text ? text : '';
    page.panelAdd.list.$focusItem.classList.add('focus');
    page.panelAdd.list.focus();
};

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( app.intent && app.intent.close ) {
                app.intent.close();
                app.intent = null;
                app.route(app.pages.main);
            } else {
                app.route(app.pages.main);
            }
            break;
    }
});

page.addListener('show', function () {
    page.panelAdd.input.innerText = '';
    page.reset();
    page.panelSet.focus();
});


// public
module.exports = page;
